module.exports = __webpack_public_path__ + "img/LogoWhitecarrot_Gris.0bb09d3e.png";